import { Component, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../../core/services/notification.service';
import { CommonModule } from '@angular/common';
import { DoctorProfileService } from '../../../core/services/doctor-profile.service';

@Component({
  selector: 'app-forgot-password-otp',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './forgot-password-otp.html',
  styleUrl: './forgot-password-otp.scss',
})
export class ForgotPasswordOtp {
  form!: FormGroup;
  errorMessage = signal<string | null>(null);
  isLoading = false;
  email: string | undefined;
  /** Pre-auth session token issued by the backend on OTP request */
  preAuthToken: string | undefined;

  constructor(
    private fb: FormBuilder,
    private profileService: DoctorProfileService,
    private notificationService: NotificationService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      otp: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]],
    });

    this.preAuthToken = history.state['preAuthToken'];
    this.email = history.state['email'];
  }

  submitOtp(): void {
    if (this.form.invalid) return;

    // Validate that we have the pre-auth token
    if (!this.preAuthToken || this.preAuthToken.trim() === '') {
      this.notificationService.error('Session expired. Please request a new OTP.');
      this.errorMessage.set('Session expired. Please request a new OTP.');
      return;
    }

    this.isLoading = true;
    this.errorMessage.set(null);

    const otpCode = this.form.get('otp')?.value;

    this.profileService
      .verifyOtpWithPreAuth('FORGOT_PASSWORD', otpCode, this.preAuthToken)
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.router.navigate(['forgot-password-change'], {
            state: { preAuthToken: this.preAuthToken },
          });
        },
        error: (error) => {
          this.isLoading = false;
          const errorMsg = error?.error?.message || 'Invalid OTP. Please try again.';
          this.notificationService.error(errorMsg);
          this.errorMessage.set(errorMsg);
        },
      });
  }
}
